export enum ClaimGeneralInformation {
    EmergencyNumber = '+31713641762',
}
